import {
  Select as UISelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";

export type SelectOption = {
  value: string;
  label: string;
  disabled?: boolean;
};

type SelectProps = {
  id?: string;
  label?: string;
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  options: SelectOption[] | readonly SelectOption[];
  disabled?: boolean;
  error?: string;
};

/** Labeled shadcn Select with optional inline error.
 *  Use with React Hook Form via Controller (value + onValueChange),
 *  or with plain useState. */
export function Select({
  id,
  label,
  value,
  onValueChange,
  placeholder,
  options,
  disabled,
  error,
}: SelectProps) {
  return (
    <div className="space-y-1.5">
      {label && <Label htmlFor={id}>{label}</Label>}
      <UISelect value={value} onValueChange={onValueChange} disabled={disabled}>
        <SelectTrigger id={id} className="w-full">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((opt) => (
            <SelectItem key={opt.value} value={opt.value} disabled={opt.disabled}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </UISelect>
      {error && <p className="text-xs text-destructive">{error}</p>}
    </div>
  );
}
